import { Type } from 'class-transformer'

import { ConnectionModel } from './components/FlowConnection/FlowConnection'
import { BaseNodeModel } from './logic/Nodes/BaseNode/BaseNodeModel'

export class FlowAccessor {
  accessorButtonClick(): void {
    return
  }

  getModel(): void {
    return
  }
}

export class ConfigDataScheme {
  index!: number

  @Type(() => BaseNodeModel)
  items!: Array<BaseNodeModel>
  @Type(() => ConnectionModel)
  connections!: Array<ConnectionModel>
  @Type(() => FlowAccessor)
  accessor!: null | FlowAccessor

  initAccessorModel() {
    return
  }

  resetAccessorModel() {
    this.accessor = null
  }
}

export class ConfigData {
  title!: string

  @Type(() => ConfigDataScheme)
  scheme!: ConfigDataScheme
}

export class FlowConfig {
  key!: string
  link!: string

  @Type(() => ConfigData)
  data!: ConfigData
}
